import React from 'react';
import { ShieldCheck, Zap, Users, Lock } from 'lucide-react';
export function TrustBar() {
  return <div className="w-full bg-[#050505] border-b border-white/5 py-2 px-2 md:px-4 z-50 relative" data-id="element-261">
      <div className="max-w-7xl mx-auto flex flex-wrap justify-center md:justify-between items-center gap-3 md:gap-4 text-[11px] md:text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-262">
        <div className="flex items-center gap-1.5 md:gap-2" data-id="element-263">
          <Lock className="w-3 h-3 text-emerald-500" data-id="element-264" />
          <span data-id="element-265">Pago 100% Seguro</span>
        </div>
        <div className="flex items-center gap-1.5 md:gap-2" data-id="element-266">
          <Zap className="w-3 h-3 text-yellow-500" data-id="element-267" />
          <span data-id="element-268">Acceso Inmediato</span>
        </div>
        <div className="flex items-center gap-1.5 md:gap-2" data-id="element-269">
          <Users className="w-3 h-3 text-blue-500" data-id="element-270" />
          <span data-id="element-271">+200 Usuarios Activos</span>
        </div>
        <div className="flex items-center gap-1.5 md:gap-2" data-id="element-272">
          <ShieldCheck className="w-3 h-3 text-purple-500" data-id="element-273" />
          <span data-id="element-274">Garantía de 72hs</span>
        </div>
      </div>
    </div>;
}